import { styled, u, keyframes } from '../../shared/theming-sc'
import { keyframesFadeIn } from '../../shared/utilities/styleUtils'

const tooltipVerticalPadding = 15
const tooltipHorizontalPadding = 20
const tooltipMaxWidth = 360
const tooltipMinWidth = 60
const tooltipZindex = 100
const tooltipLineHeight = 24

const keyframesScaleIn = keyframes`
  from{
    transform: scale(0.85);
  }
  to{
    transform: scale(1);
  }
`

const StyledTooltip = styled.div`
  display: inline-block;
  position: relative;
  line-height: ${p => p.isIcon ? 1 : 'inherit'};
  vertical-align: ${p => p.isIcon ? 'middle' : 'baseline'};
  margin: 0 4px;
  max-width: ${p => p.truncate ? '100%' : 'none'};
`

const StyledTooltipPointer = styled.div`
  position: absolute;
  top: ${p => p.closeToTop ? 'calc(100% + 4px)' : 'auto'};
  bottom: ${p => p.closeToTop ? 'auto' : 'calc(100% + 4px)'};
  left: 50%;
  width: 12px;
  height: 12px;
  opacity: ${p => p.visible ? 1 : 0};
  visibility: ${p => p.visible ? 'visible' : 'hidden'};
  border-right: 1px solid ${u.getColor('greyMuted')};
  border-bottom: 1px solid ${u.getColor('greyMuted')};
  background: white;
  box-shadow: ${p => p.closeToTop ? 'none' : '6px 2px 5px -1px rgba(0, 0, 0, 0.15)'};
  transform: translateX(-50%) rotate(${p => p.closeToTop ? '225deg' : '45deg'});
  z-index: ${tooltipZindex + 1};
`

const StyledTooltipText = styled.div.attrs({
  style: ({visible, closeToTop, extraStyles}) => {
    const s = {
      top: closeToTop ? '100%' : 'auto',
      bottom: closeToTop ? 'auto' : '100%',
      marginTop: closeToTop ? '10px' : '0',
      marginBottom: closeToTop ? '0' : '10px',
      opacity: visible ? 1 : 0,
      visibility: visible ? 'visible' : 'hidden',
      animation: visible ? `${keyframesScaleIn} 0.2s cubic-bezier(0.3,0.7,0,1), ${keyframesFadeIn} 0.125s linear` : '',
      ...extraStyles
    }

    return s
  }
})`
  display: inline-block;
  position: absolute;
  left: 0;
  min-width: ${tooltipMinWidth}px;
  max-width: ${tooltipMaxWidth}px;
  padding: ${tooltipVerticalPadding}px ${tooltipHorizontalPadding}px;
  font-family: ${u.getFontFamily('knowledge', 'regular')};
  font-size: ${u.getFontSize('md')};
  line-height: ${tooltipLineHeight}px;
  text-transform: none;
  letter-spacing: 0;
  color: ${u.getColor('greyDark')};
  border: solid 1px ${u.getColor('greyMuted')};
  border-radius: 5px;
  background: white;
  box-shadow: 5px 5px 4px 0 rgba(0, 0, 0, 0.2);
  z-index: ${tooltipZindex};
  transform-origin: 50% 100%;
`

const StyledTooltipTextInner = styled.span`
  white-space: ${p => p.resized ? 'normal' : 'nowrap'};
`

const StyledTooltipTrigger = styled.div`
  display: inline-block;
  cursor: pointer;
  text-transform: none;
  letter-spacing: 0;
  line-height: inherit;
  text-overflow: ${p => p.truncate ? 'ellipsis' : 'clip'};
  overflow: ${p => p.truncate ? 'hidden' : 'visible'};
  max-width: ${p => p.truncate ? '100%' : 'none'};
  white-space: ${p => p.truncate ? 'nowrap' : 'normal'};

  &:hover {
     ~ ${StyledTooltipPointer},
     ~ ${StyledTooltipText} {
      opacity: 1;
    }
  }
`

export {
  StyledTooltip,
  StyledTooltipTrigger,
  StyledTooltipPointer,
  StyledTooltipText,
  StyledTooltipTextInner,
  tooltipVerticalPadding,
  tooltipHorizontalPadding,
  tooltipMaxWidth,
  tooltipMinWidth,
  tooltipLineHeight
}
